import type { InsightResponse } from "@ishvaram/api-client";
import { API_BASE, apiBlobRequest, apiRequest } from "./_fetch";

export type { InsightResponse };

export async function getDailyInsight(): Promise<InsightResponse> {
  return apiRequest<InsightResponse>("/insights/today");
}

export async function getPersonalizedInsight(rashi: string): Promise<InsightResponse> {
  return apiRequest<InsightResponse>(`/insights/today/${rashi}`);
}

export function getInsightCardUrl(rashi: string): string {
  return `${API_BASE}/insights/today/${rashi}/card`;
}

export function getShareCardUrl(readingId: string): string {
  return `${API_BASE}/share-card/${readingId}`;
}

export function getShareCardOgUrl(readingId: string): string {
  return `${API_BASE}/share-card/${readingId}/og`;
}

export function getSharePageUrl(readingId: string): string {
  return `${API_BASE}/share/${readingId}`;
}

export async function downloadShareCard(readingId: string): Promise<Blob> {
  return apiBlobRequest(`/share-card/${encodeURIComponent(readingId)}`, {}, 30_000);
}
